module.exports = __webpack_public_path__ + "img/bz.ec11228f.png";